import React from 'react';
import './PageCloseButton.css';

interface PageCloseButtonProps {
  onClick: () => void;
  ariaLabel?: string;
  variant?: 'page' | 'dialog';
}

const PageCloseButton: React.FC<PageCloseButtonProps> = ({
  onClick,
  ariaLabel = 'Close',
  variant = 'page'
}) => (
  <button
    type="button"
    className={`page-close-btn${variant === 'dialog' ? ' page-close-btn--dialog' : ''}`}
    onClick={onClick}
    aria-label={ariaLabel}
  >
    ×
  </button>
);

export default PageCloseButton;
